<mat-calendar [headerComponent]="DATE_PICKER_HEADER" [minDate]="DEFAULT_DATE" [startAt]="selectedDate" (selectedChange)="selectedDate = $event"></mat-calendar>
<div class="flex-row flex-space-between pl-8 pr-8 pb-8">
  <button mat-button class="compact" (click)="applyDate(TODAY)">{{ 'CALENDAR.SCHEDULE.TODAY' | bmsTranslate }}</button>
  <button mat-button class="compact" (click)="applyDate()">{{ 'GENERAL.ACTIONS.APPLY' | bmsTranslate }}</button>
</div>
